import React from 'react';
import Component from '../component';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import actions from './actions';
import reducer from './reducer';

export class PureScrollShow extends Component {
  static reducer = { scrollShow: reducer };
  static propTypes = {
    threshold: PropTypes.number.isRequired,
    isVisible: PropTypes.bool.isRequired,
    setVisibility: PropTypes.func.isRequired
  };

  componentDidMount() {
    window.addEventListener('scroll', this.onPageScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onPageScroll);
  }

  onPageScroll() {
    this.props.setVisibility(window.scrollY, this.props.threshold);
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.isVisible !== this.props.isVisible;
  }

  render() {
    return this.props.isVisible
      ? <div>{ this.props.children }</div>
      : null;
  }
}

export function mapStateToProps(state) {
  return {
    isVisible: state && state.hasOwnProperty('scrollShow') && state.scrollShow.isVisible
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    setVisibility: (y, threshold) => {
      return dispatch(actions.setVisibility(y, threshold));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PureScrollShow);


// WEBPACK FOOTER //
// ./src/components/scroll-show/index.jsx